import { axiosV1 } from 'interceptors/axios';
import { store } from 'redux/store';
import { addAlert } from 'modules/_shared/redux/alertActions';
import alertBodyTypes from 'modules/_shared/components/Alert/alertBodyTypes';
import {
  addDocument,
  getDocuments,
} from 'modules/documents/redux/documentActions';
import { setModal } from 'modules/_shared/redux/modalActions';

import { decryptResponse } from './token';

export default async function duplicateDocument(document, notPreview) {
  try {
    const { name, _id, date, ...documentData } = document;
    let newDocument = {};
    if (notPreview) {
      const { data } = await axiosV1.get(`/download/${_id}`);
      const decodedData = await decryptResponse(data);
      const url = decodedData?.url;
      await fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const documentFile = new File([blob], `Copia ${name}`, {
            type: 'application/pdf',
          });
          newDocument = {
            name: `Copia ${name}`,
            file: documentFile,
            size: documentFile.size,
            date: new Date(),
            ...documentData,
          };
        })
        .catch(() => {
          store.dispatch(addAlert(alertBodyTypes.ERROR_DUPLICATING_DOCUMENT));
        });
    } else {
      newDocument = {
        name: `Copia ${name}`,
        date: new Date(),
        ...documentData,
      };
    }
    await store.dispatch(addDocument(newDocument));
    store.dispatch(getDocuments({ society: documentData.society }));
    store.dispatch(addAlert(alertBodyTypes.DOCUMENT_DUPLICATED));
  } catch (error) {
    store.dispatch(addAlert(alertBodyTypes.ERROR_DUPLICATING_DOCUMENT));
  } finally {
    store.dispatch(setModal(null));
  }
}
